import React, { useEffect, Component, Fragment, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Spinner from "react-bootstrap/Spinner";
import Toast from "react-bootstrap/Toast";
import Tooltip from "react-bootstrap/Tooltip";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable';
import ClientMetricList from './ClientMetricList'
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";
import useApiStatusEnvAwarePost from "../../hooks/useApiStatusEnvAwarePost"
import {
	getClientMetrics,
	updateMetricOrder,
	// getCategories,
	createMetric,
	createCategory,
	getAllMetricsByCategory,
	updateLocalMetricOrder,
	// selectCategoryById
	// updateMetricGroupings,
	deleteCategory,
	deleteMetric,
	updateMetric,
	selectAllMetrics
} from "../../state/metricListSlice";
import {envAwarePost} from '../../util/util'
import classes from "./MetricList.module.css";

import { getAllClients, selectAllClients, selectTrainerParam } from "../users/usersSlice"
// import { getAllEventsTemplates } from "../EventsView/eventsViewSlice";
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';

const CopyMetricModal = ({show,onHide})=>{

	const [defaultsStatus,setDefaultsStatus] = useState('pending')
	const [defaults,setDefaults] = useState([])
	const [selectedDefaults,setSelectedDefaults] = useState([])

	const [clientsStatus,setClientsStatus] = useState('pending')
	const [clients,setClients] = useState([])
	const [selectedClients,setSelectedClients] = useState([])

	useEffect(()=>{
		if (!show) return 
		setSelectedDefaults([])
		setSelectedClients([])

		setDefaultsStatus('pending')
		envAwarePost('api/metrics/api/',{
			'action':'getDefaultMetrics'
		}).then(res=>{
			setDefaultsStatus('idle')
			setDefaults(res.data.metrics)
		})

		setClientsStatus('pending')
		envAwarePost('api/users/api/',{
			'action':'getAllClients'
		}).then(res=>{
			setClientsStatus('idle')
			setClients(res.data)
		})

	},[show])

	const [copyStatus,setCopyStatus] = useState('idle')
	const statusPost = useApiStatusEnvAwarePost()
	const handleCopy = ()=>{
		const metric_ids = selectedDefaults.map(d=>d.value)
		const client_ids = selectedClients.map(c=>c.value)
		setCopyStatus('pending')
		statusPost('api/metrics/api/',{
			action:'copyMetricsToClients',
			metric_ids,
			client_ids
		},'metrics','copi').then(res=>{
			setCopyStatus('idle')
			if(res.success==='1'){
				setSelectedDefaults([])
				setSelectedClients([])
				onHide()
			}
		})
	}

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header>
				<Modal.Title>Copy Metrics</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<strong>
					Select Metrics
				</strong>
				<Select
					options={defaults.map(c=>({
						value:c.assessment_id,
						label:c.assessment_name
					}))}
					value={selectedDefaults}
					onChange={newSelectedDefaults => {
						setSelectedDefaults(newSelectedDefaults)
					}}
					isMulti
				/>
				<strong>
					Select Clients
				</strong>
				<Select
					options={clients.map(c=>({
						value:c.user_id_number,
						label:c.user_name
					}))}
					value={selectedClients}
					onChange={newSelectedClients => {
						setSelectedClients(newSelectedClients)
					}}
					isMulti
				/>
				<Button 
					disabled={
						copyStatus==='pending' ||
						!selectedClients.length ||
						!selectedDefaults.length
					}
					onClick={handleCopy} 
					className="mt-2" 
					variant="outline-success" 
					block size="sm"
				>
					Copy {copyStatus==='pending'&&<Spinner animation="border" size="sm"/>}
				</Button>
			</Modal.Body>
		</Modal>
	)
}

const MetricList = () => {
	const history = useHistory()
	// let client_Id = window.location.href.split('=')[1]
	const url = new URL(window.location.href);
	const client_Id = (url.searchParams.get("clientId"))?.split('?')[0];
	const trainerId = url.searchParams.get("trainer");
	//gets user ID from the URL, if undefined sets as trainer ID
	useEffect(() => {
		//make sure all clients are fetched
		dispatch(getAllClients({}))
	}, [])

	//get metric units
	const [metricUnits,setMetricUnits] = useState([])
	useEffect(()=>{
		envAwarePost('api/metrics/api/',{
			action:'getMetricUnits'
		}).then(res=>{
			setMetricUnits(res.data.units)
		})
	},[])

	const isTrainer = useSelector((state) => state.users.current_user.account_type) === "trainer"
	const isGym = useSelector((state) => state.users.current_user.account_type) === "gym"
	const hasPermission = useSelector((state) => state.users.current_user.edit_permissions?.assessmentList) === "1"

	// const userID = useSelector((state) => state.user.user?.user_id);
	const trainerID = useSelector((state) => state.users.current_user?.user_id_number);

	const trainerParam = useSelector(selectTrainerParam)

	const clientsData = useSelector((selectAllClients))
	const metricStatus = useSelector((state) => state.metrics);

	const assessmentList = Object.values(useSelector((state) => state.metrics.entities));


	const dispatch = useDispatch();
	const statusDispatch = useApiStatusDispatch();


	const nameRef = useRef();

	const [itemName, setItemName] = useState("");
	const [itemDesc, setItemDesc] = useState("");
	const [itemCategory, setItemCategory] = useState('')
	const [defaultassessment, setDefaultAssessment] = useState(0);
	const [isIntegrated, setIsIntegrated] = useState(false);
	const [integrationId, setIntegrationId] = useState(0);
	const [clients, setClients] = useState("single");
	const [assessmentID, setAssessmentID] = useState("");
	const [clientId, setClientId] = useState(client_Id||trainerID);
	const [orderDiff, setOrderDiff] = useState({})
	const [dragDisabled, setDragDisabled] = useState(true)
	const [clientName, setClientName] = useState("Default")
	const [showToast, setShowToast] = useState(true);
	const [isSelectLoading, setIsSelectLoading] = useState(false) //for createable select 
	const [toDelete, setToDelete] = useState({})
	const [metricSort, setMetricSort] = useState(false)
	const [categoryPlaceholder, setCategoryPlaceholder] = useState('')
	const [editToggle, setEditToggle] = useState(false)
	const [isLoading, setIsLoading] =useState(false)
	const [showAddCategory,setShowAddCategory] = useState(false)
	const [categoryName,setCategoryName] = useState('')
	const [selectedUnit,setSelectedUnit] = useState(1)
	const metrics = useSelector(selectAllMetrics)
	const [showCopyModal,setShowCopyModal] = useState(false)

	//gets all metrics upon client select or dispatch
	useEffect(() => {
		setIsLoading(true)
		let type;
		let include_progress_data=0
		let client_Id;
		let include_empty_groups=1
		if (clientId === 0){
			client_Id = trainerID
			type = 'default'
		} else {
			client_Id = clientId
			type = 'client'
		}

		const payload = {
			type,
			client_Id,
			include_progress_data,
			include_empty_groups
		}
		dispatch(getAllMetricsByCategory(payload)).then(() => {
			setIsLoading(false)
		})
	}, [clientId, editToggle])

	const metricsListSorted = Object.values(useSelector((state) => state.metrics.entities)).sort(function(a,b){
		let textA = a.assessment_name.toUpperCase();
		let textB = b.assessment_name.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	}).sort(function(a,b){
		let textA = a.categorization.toUpperCase();
		let textB = b.categorization.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	})

	const ids =(useSelector((state) => state.metrics.ids))
	const categories = Object.values(useSelector((state) => state.metrics.categories.entities))

	// filters the clientlist so only trainer's clients are shown
	const filteredData = clientsData.filter(client => client.user_trainer_id == trainerID)

	// checks if cleint is already selected. If not, formats the client list for a select menu
	let  clientOptions= filteredData.map(client => {
		if(clientId !== client.user_id_number){
			return {
			label:client.user_name,
			value:client.user_id_number,
			key:client.user_id_number
			}
		}
	})

	// checks if the selected user is 'default'. If not, adds a default option
	if(clientId !== trainerID && clientId !== undefined){
		clientOptions=[{label:'Default', value:trainerID,key:999},...clientOptions]
	}

	//finds the selected client and sets their name in state
	useEffect(() => {	
		const name = filteredData.filter(client => client.user_id_number == clientId)
		if(clientId == 0 || name[0]===undefined){
			setClientName("Default")
		} else {
			setClientName(name[0]?.user_name)
		}
	}, [clientId])

	//resets all form's inputs
	const resetFormState = () => {
		setItemName("");
		setItemDesc("");
		setDefaultAssessment(0);
		setIsIntegrated(false);
		setIntegrationId(0);
		setClients("single");
		setCategoryPlaceholder('')
	}

	//Add Modal
	const [showAddmodal, setShowAddModal] = useState(false);
	const handleAddClose = () => {
		setShowAddModal(false)
		resetFormState()
	}
	const handleAddShow = () => {
		setShowAddModal(true)
	}

	//Edit Modal
	const [showEditModal, setShowEditModal] = useState(false);
	const handleEditClose = () => {
		setShowEditModal(false)
		resetFormState()
	}
	const handleEditShow = (categorization) => {
		setCategoryPlaceholder(categorization)
		setItemCategory({label:categorization})
		setShowEditModal(true)
	}

	// Manage Categories Modal 
	const [showCategorymodal, setShowCategoryModal] = useState(false);
	const handleCategoryClose = () => {
		setShowCategoryModal(false);
		setShowAddCategory(false)
		resetFormState();
	}
	const handleCategoryShow = () => setShowCategoryModal(true);

	//Metric Integrations
	const metricIntegrations = [{ text: "One Rep Max", value: 1 }];

	//returns the state of the 'add metric to all clients' checkbox 
	const clientsToggle = () => {
		if (clients === "single") {
			return "allClients"
		} else {
			return "single"
		}
	}

	//User Permissions
	const assessmentList_edit = useSelector(
		//should always be true for trainers
		(state) => true //state.user.user.assessmentList_edit
	);

	//finds category id then either dispatches one 'addMetric' or many for every client and default
	// depending on if 'add metric to all clients' has been selected
	const addMetric = (e) => {
		e.preventDefault()
		let category_id;
		if(itemCategory === ''){
			category_id = 0
		} else if(itemCategory.value !== null) {
			category_id = itemCategory.value
		} else {
			category_id = (categories.find(category => category.category === itemCategory.label)).category_id
		}
		let preferred_order = metrics.length // add new metric to bottom of list on reload
		let type;
		let client_Id;
		let payload;
		if (clients === 'single') {
			if (clientId === 0){
				client_Id = trainerID
				type = 'default'
			} else {
				client_Id = clientId
				type = 'client'
			}
			payload = {
					type,
					client_Id,
					category_id,
					itemName,
					itemDesc,
					integrationId,
					preferred_order,
					unit_id:selectedUnit,
					add_to_all:0
			}
			statusDispatch(createMetric(payload), "metric","create")

		} else {
			client_Id = trainerID
			type = 'default'
			payload = {
				type,
				client_Id,
				category_id,
				itemName,
				itemDesc,
				integrationId,
				preferred_order,
				unit_id:selectedUnit,
				add_to_all:1
			}
			statusDispatch(createMetric(payload),"metric","create")
			if(clientId !== 0){
				client_Id = trainerID
				type = 'default'
				payload = {
					type,
					client_Id,
					category_id,
					itemName,
					itemDesc,
					integrationId,
					preferred_order,
					unit_id:selectedUnit,
					add_to_all:0
				}
				statusDispatch(createMetric(payload),"metric","create")
			}
		}
		handleAddClose()
	}

	//finds category id then dispatches to edit a metric
	const editAssessmentFunc = () => {
		let category_id;
		if(itemCategory === ''){
			category_id = 0
		} else if(itemCategory.value) {
			category_id = itemCategory.value
		} else {
			category_id = (categories.find(category => category.category === itemCategory.label)).category_id
		}
		let	payload = {
			name:itemName,
			description:itemDesc,
			integration_id:integrationId,
			metric_id:assessmentID,
			unit_id:selectedUnit,
			category_id:category_id
		}
		statusDispatch(updateMetric(payload), "metric","update")
		// dispatch(updateMetric(payload))
		.then(() => {
			setEditToggle(!editToggle)
			handleEditClose();
			setCategoryPlaceholder('')
		})


	}

	// sets the state to the clicked metric's details for the edit form
	const setAssessmentToEdit = (assessment) => {
		setAssessmentID(assessment.assessment_id);
		setItemName(assessment.assessment_name);
		setItemDesc(assessment.description);
		setIntegrationId(assessment.integration_id);
		setCategoryPlaceholder(assessment.categorization)
		setIsIntegrated(assessment.integration_id == 0 ? false : true);
		setSelectedUnit(assessment.unit_id)
	}

	//saves the order of the dragged and dropped metric list
	const saveOrder = () => {
		const payload = {
			clientId,
			orderDiff
		}
		// dispatch(updateMetricOrder(payload))
		statusDispatch(updateMetricOrder(payload),"Metric order","update")
		// .then(() => {
		// 	// dispatch(getClientMetrics(payload));
		// })
		setDragDisabled(true)
	}


	//sets the order of the metric list after a user drags and drops a  metric
	function handleOnDragEnd(result) {
		const items = Array.from(JSON.parse(JSON.stringify(metrics))) //stringified to deep copy data
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		if (!result.destination) return;
		const orderObj = Object.fromEntries(items.map((item, index) => [item.assessment_id, index]))
		dispatch(updateLocalMetricOrder({items, orderObj}))

		setOrderDiff(orderObj)
	}

	const handleAddCategory = (e) => {
		e.preventDefault()
		addCategory(categoryName)
		setCategoryName('')

		setShowAddCategory(false)
	}

	//adds a category
	const addCategory = (inputValue) => {
		const payload = {
			inputValue
		}
		statusDispatch(createCategory(payload),"category","create")
	}

	//maps the list of categories for the select menu
	const mapCategoriesToSelectObjects = array => (
		(array?.reverse()).map(c => {
			return {
				label:c.category,
				value:c.category_id
			}
		})
	)

	//sets a selected category to state
	const handleOptionChange = (newValue) => {
		setItemCategory(newValue)
	}

	// when a user creates a new category, it sets a loading spinner for 1 second (to simulate updating the database)
	// then sets the state of selected category to the newly created category
	const handleOptionCreate = (inputValue) => {
		setIsSelectLoading(true)
		console.group('Option created');
		console.log('Wait a moment...');
		addCategory(inputValue)
		setTimeout(() => {
			setIsSelectLoading(false)
			let newCategory = {
				label: inputValue,
				value: null
			}
			setItemCategory(newCategory)
		}, 1000);
	}

	//checks if category is used for any existing metric, if so notifies the user. if not used, proceeds
	// to delete the category
	const deleteCategoryHandler = (id,name) => {
		let isEmpty = true
		metrics.forEach(metric => {
			if(metric.categorization === name){
				isEmpty=false
			}
		})
		if(!isEmpty){
			window.alert("You must delete or move all metrics in this Category before deleting it")
		} else {
			let payload={category_id:id}
			statusDispatch(deleteCategory(payload),"category","delete")
		}
	}

	//upon the delete checkbox click, deep copies the toDelete list then either adds or removes the checked(or unchecked) metric
	const handleDeleteToggle =(id) => {
			let newToDelete = JSON.parse(JSON.stringify(toDelete))
		if(toDelete[id] !== undefined){
			delete newToDelete[id]
		} else {
			newToDelete[id] = id
		}
		setToDelete(newToDelete)
	}

	// when user clicks the garbage can icon, it finds client ID, notifies user then 
	// deletes each metric that is in the toDelete state and resets the toDelete state
	const handleDeleteMetrics = () => {
		let client_Id
		if (clientId === 0){
			client_Id = trainerID
		} else {
			client_Id = clientId
		}
		if (window.confirm('Are you sure you want to delete the selected metrics and all the data associated with them?')) {
			Object.keys(toDelete).forEach(id => {
				let payload = {
					client_Id,
					id
				}
				statusDispatch(deleteMetric(payload), "metric", "delete")
			})
			setToDelete({})
		}
	}

	// when a user clicks the delete all checkbox, either unchecks everything if already checked
	// or checks everything if none or some metrics are checked
	const toggleDeleteAll = () => { 
		if(Object.keys(toDelete).length === metrics.length){
			setToDelete({})
		} else {
			let newToDelete = {}
			metrics.forEach(metric => (
				newToDelete[metric.metric_id] = metric.metric_id
			))
			setToDelete(newToDelete)
		}
	}

	// checks if a metric id is within the toDelete object
	const inDeleteList = (id) => {
			if(toDelete[id] !== undefined){
				return true
			} else {
				return false
			}
	}

	//upon sort metrics button click grabs the button then checks if metricSort is true
	// either sets to false and removes the color class or true and adds color class
	const handleMetricSort =() => {
		let button =document.getElementById('metricsSortButton')
		if(metricSort){
			setMetricSort(false)
			button.classList.remove(classes.sortSelected)
		} else { 
			setMetricSort(true)
			button.classList.add(classes.sortSelected)
		}
	}

	if(!isTrainer && !hasPermission && !isGym){
		return <ClientMetricList/>
	} else {

	return (
		<>
			<div className={[classes.AssessmentList].join(' ')} id="containerDiv">
				<div className="pt-2 px-2 px-md-3">
					{isTrainer 
						? clientName === 'Default' ? <strong>Default Metrics</strong> : <strong>{clientName}'s Metrics</strong> 
						: <strong>Metrics</strong>
					}
				</div>
				{assessmentList_edit == 1 ?

					<React.Fragment>
						<div className="px-2 px-md-3">
							{(clientId != 0 && !isGym) &&
									
								<small className="d-none d-md-block">
									Below are the different progress metrics that can be measured and
									recorded on the {clientName !== 'Default' ? 
										<>
													<Button
													variant='link'
													className={classes.assessmentLinkButton}
													as={Link}
													to={`/metric-graphs?clientId=${clientId}&${trainerParam}`}
												> Progress</Button>page.
										</>
										:
										"Progress page. Select a client to enter progress for."
									}
								</small>
							}

							{isTrainer &&
								<div className="my-1 d-flex align-items-center">
									<strong className="mr-2">Clients:</strong>
									<Form.Control
										as="select"
										onChange={(e) => {e.preventDefault(); setClientId(e.target.value) ;}}

									>
										<option value={clientId}>{clientName}</option>
										{
											clientOptions.map(option => {
												if(option.label !== clientName){
													return(
														<option
														key={option.key}
														value={option.value}
														>
															{option.label}
														</option>
													)
												}
											})
										}

									</Form.Control>
								</div>			
							}
							<div className="text-right">
								{isTrainer &&
									<OverlayTrigger
										placement={"top"}
										overlay={
										<Tooltip id={`tooltip-top`}>
											Create or delete a category
										</Tooltip>
										}
									>
									<Button
										className="ml-1 mb-1"
										onClick={() => handleCategoryShow()}
										size="sm"
										variant="outline-secondary"
									>
										<i className="fa fa-cog"/>
									</Button>
									</OverlayTrigger>
								}
								<OverlayTrigger
									placement={"top"}
									overlay={
									<Tooltip id={`tooltip-top`}>
										Sort Metrics by category and name
									</Tooltip>
									}
								>
									<Button 
										className="ml-1 mb-1"
										size='sm'
										onClick={handleMetricSort}
										variant="outline-secondary"
										disabled={!dragDisabled}
									>
										Sort <span className="d-none d-sm-inline">Metrics</span>
									</Button>
								</OverlayTrigger>
								<Button
									className="ml-1 mb-1"
									onClick={() => handleAddShow()}
									size="sm"
									variant="outline-success"
								>
									Add <span className="d-none d-sm-inline">Metric</span>
								</Button>
								{clientName==='Default'&&
									<OverlayTrigger overlay={
										<Tooltip>
											Copy default metrics to client accounts
										</Tooltip>	
									}>
										<Button
											className="ml-1 mb-1"
											onClick={() => {
												setShowCopyModal(true)
											}}
											size="sm"
											variant="outline-primary"
										>
											Copy <span className="d-none d-sm-inline">Metrics</span>
										</Button>
									</OverlayTrigger>
								}
								{dragDisabled ? (
									<Button
										className="ml-1 mb-1"
										onClick={() => setDragDisabled((prev) => !prev)}
										size="sm"
										variant="outline-danger"
										disabled={metricSort}
									>
										Change Order
									</Button>
								) : (
										<Button
											className="ml-1 mb-1"
											className={classes.metricButton}
											onClick={() => saveOrder()}
											size="sm"
										>
											Save Order
										</Button>
									)
								}
							</div>

							{
								metricStatus.status === 'added' &&
								<Toast onClose={() => setShowToast(false)} show={showToast} delay={2000} autohide style={{ color: 'white', backgroundColor: '#4FD69C' }}>
									<Toast.Body><strong>Item Successfully Added!</strong></Toast.Body>
								</Toast>
							}

							{
								metricStatus.status === 'edited' &&
								<Toast onClose={() => setShowToast(false)} show={showToast} delay={2000} autohide style={{ color: 'white', backgroundColor: '#4FD69C' }}>
									<Toast.Body><strong>Item Successfully Edited!</strong></Toast.Body>
								</Toast>
							}
						</div>
						{
							// metricStatus.status === 'loading' ? (
								isLoading ? (
								<div style={{ display: 'flex', justify_content: 'center' }}>
									<Spinner animation="border" role="status" variant="primary" >

									</Spinner>
								</div>
							)
								: (
									<Table bordered hover className={classes.metricListTable}>
										<thead style={{ backgroundColor: "#172B4D", color: "#fff" }}>
										{/* <thead style={{backgroundColor: "white"}}> */}
											<tr>
												<th> Metric Name</th>
												<th>Category</th>
												<>
												{isTrainer && 
												 	<td style={{width:'70px'}}>
													<div className="d-flex align-items-center">
														<Form.Check
															onChange={toggleDeleteAll}
															checked={Object.keys(toDelete).length === metrics.length}
															type="checkbox"
															aria-label="check all"
														/>
														<Button 
															disabled={Object.keys(toDelete).length === 0}
															onClick={handleDeleteMetrics} 
															variant="danger"
															size="sm">
															<i className="fa fa-trash"/>
														</Button>
													</div>
												</td>
												}
												</>
											</tr>
										</thead>
										{metricSort ? 
													<tbody className="metricList" style={dragDisabled ? { backgroundColor: 'white' } : { backgroundColor: '#efeaff' }}>
													{metricsListSorted?.map((val, index) => (
																<tr>
																	<td
																		style={{ cursor: "pointer" }}
																		onClick={() => {
																			setAssessmentToEdit(val);
																			handleEditShow(val?.categorization);
																		}}
																	>
																		<span className={classes.AssessmentName}>
																			{val?.assessment_name}
																		</span>
																		{val?.description}
																	</td>
																	<td>{val?.categorization}</td>
																	{isTrainer &&
																			<td>
																				<Form.Check
																					onChange={()=>handleDeleteToggle(val.metric_id)}
																					checked={(inDeleteList(val.metric_id))}
																					type="checkbox"
																					aria-label="check all"
																				/>
																			</td>
																			}
																</tr>
													))}
												</tbody>
										:

										<DragDropContext onDragEnd={handleOnDragEnd}>
											<Droppable droppableId="metricList">
												{(provided) => (
													<tbody className="metricList" {...provided.droppableProps} ref={provided.innerRef} style={dragDisabled ? { backgroundColor: 'white' } : { backgroundColor: '#efeaff' }}>
														{metrics?.map((val, index) => (
															<Draggable key={val?.metric_id} draggableId={val?.metric_id.toString()} index={index} isDragDisabled={dragDisabled}>
																{(provided) => (
																	<tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
																		<td
																			style={{ cursor: "pointer" }}
																			onClick={() => {
																				setAssessmentToEdit(val);
																				handleEditShow(val?.categorization);
																			}}
																		>
																			<span className={classes.AssessmentName}>
																				{val?.assessment_name}
																			</span>
																			{val?.description}
																		</td>
																		<td>{val?.categorization}</td>
																		{isTrainer &&
																			<td>
																				<Form.Check
																					onChange={()=>handleDeleteToggle(val.metric_id)}
																					checked={(inDeleteList(val.metric_id))}
																					type="checkbox"
																					aria-label="check all"
																				/>
																			</td>
																			}
																	</tr>
																)}
															</Draggable>
														))}
														{provided.placeholder}
													</tbody>
												)}
											</Droppable>
										</DragDropContext>

									}

									</Table>
								)
						}
						{/* Add modal */}
						<Modal show={showAddmodal} onHide={handleAddClose}>
							<Modal.Header closeButton>
								<Modal.Title className={classes.ModalTitle}>
									Add Metric
							</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<Form style={{ padding: 20 }}>
									<Form.Group>
										<Form.Label>Metric Name:</Form.Label>
										<Form.Control
											type="text"
											name="itemName"
											onChange={(e) => setItemName(e.target.value)}
											value={itemName}
										/>
									</Form.Group>
									<Form.Group>
										<Form.Label>Description:</Form.Label>
										{/* <Form.Control
											type="text"
											name="itemDesc"
											onChange={(e) => setItemDesc(e.target.value)}
											value={itemDesc}
										/> */}
										<textarea 
										class="form-control" 
										name="itemDesc"
										onChange={(e) => setItemDesc(e.target.value)}
										value={itemDesc}
										></textarea>
									</Form.Group>
									<Form.Group>
										<Form.Label>Unit:</Form.Label>
										<Form.Control 
											onChange={e=>{
												setSelectedUnit(e.target.value)
											}}
											as="select"
										>
											{metricUnits.map(unit=>(
												<option value={unit.id}>
													{unit.unit}
												</option>
											))}
										</Form.Control>
										<small>
											<i className="fa fa-info-circle mr-1"/> 
											Time units are measured using MM:SS
										</small>
									</Form.Group>
									<Form.Group>
										<Form.Label>Select or Create Category:</Form.Label>
										<CreatableSelect
											isClearable
											isDisabled={isSelectLoading}
											isLoading={isSelectLoading}
											onChange={(e) => handleOptionChange(e)}
											onCreateOption={(e) => handleOptionCreate(e)}
											options={mapCategoriesToSelectObjects(categories)}
											value={itemCategory}
										/>
									</Form.Group>

									<div style={{ display: "flex", alignItems: "center" }} onClick={() => setIsIntegrated((prev) => !prev)}>
										<Form.Check
											name="isIntegrated"
											type="checkbox"
											checked={isIntegrated}
											// onChange={() => setIsIntegrated((prev) => !prev)}
											label="Integrate this metric"
											style={{ marginRight: 10 }}
										/>
										<OverlayTrigger
											placement={"top"}
											overlay={
												<Tooltip id={`tooltip-top`}>
													Integrate metrics are special metrics that integrate into
													other features
												</Tooltip>
											}
										>
											<i
												className="fas fa-info-circle"
												style={{ color: "#525F7F" }}
											></i>
										</OverlayTrigger>
									</div>

									{isIntegrated && (
										<div style={{ margin: "10px 0px" }}>
											<select
												value={integrationId}
												onChange={(e) => {
													setIntegrationId(e.target.value);
												}}
											>
												<option value={0} selected>
													---
												</option>
												{metricIntegrations.map((metric) => (
													<option value={metric.value}>{metric.text}</option>
												))}
											</select>
										</div>
									)}
									{integrationId != "0" && (
										<div>
											<div className={classes.MetricsSubHeader}>
												Metric Integrations
											</div>
											<div className={classes.Subtext}>
												The maximum weight at which a person can perform one rep of
												an exercise. Integrates with % Max Calculator on the workout
												creator.
											</div>
										</div>
									)}
									{isTrainer &&
										<div onClick={() => setClients(clientsToggle)}>
											<Form.Check
												name="clients"
												type="checkbox"
												checked={clients === "allClients"}
												// onChange={() => setClients(clientsToggle)}
												label="Add to All Existing Clients"
												style={{ marginRight: 10 }}
											/>
										</div>
									}
									<hr />
									{clientId === 0 ? 
										(
											<Button
												size="sm"
												style={{
													float: "right",
													fontWeight: "bold",
												}}
												className='btn btn-success'
												onClick={(e) => addMetric(e)}
											>
												Add to Defaults
											</Button>
										) : (
											<Button
												size="sm"
												className='btn btn-success'
												onClick={(e) => { addMetric(e) }}
											>
												Add Metric
											</Button>
										)
									}

								</Form>
							</Modal.Body>
						</Modal>

						{/* Edit modal */}
						<Modal show={showEditModal} onHide={handleEditClose}>
							<Modal.Header closeButton>
								<Modal.Title className={classes.ModalTitle}>
									Edit Metric
								</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<Form style={{ padding: 20 }}>
									<Form.Group>
										<Form.Label>Metric Name:</Form.Label>
										<Form.Control
											type="text"
											name="itemName"
											onChange={(e) => setItemName(e.target.value)}
											value={itemName}
										/>
									</Form.Group>
									<Form.Group>
										<Form.Label>Description:</Form.Label>
										<textarea 
											class="form-control" 
											name="itemDesc"
											onChange={(e) => setItemDesc(e.target.value)}
											value={itemDesc}
										></textarea>
									</Form.Group>
									<Form.Group>
										<Form.Label>Unit:</Form.Label>
										<Form.Control 
											onChange={e=>{
												setSelectedUnit(e.target.value)
											}}
											value={selectedUnit}
											as="select"
										>
											{metricUnits.map(unit=>(
												<option value={unit.id}>
													{unit.unit}
												</option>
											))}
										</Form.Control>
										<small>
											<i className="fa fa-info-circle mr-1"/> 
											Time units are measured using MM:SS
										</small>
									</Form.Group>
									<Form.Group>
										<Form.Label>Select or Create Category:</Form.Label>
										<CreatableSelect
											isClearable
											isDisabled={isSelectLoading}
											isLoading={isSelectLoading}
											onChange={(e) => handleOptionChange(e)}
											onCreateOption={(e) => handleOptionCreate(e)}
											options={mapCategoriesToSelectObjects(categories)}
											value={itemCategory}
											placeholder={categoryPlaceholder}
										/>
									</Form.Group>
									<div style={{ display: "flex", alignItems: "center" }}>
										<Form.Check
											name="isIntegrated"
											type="checkbox"
											checked={isIntegrated}
											onChange={() => {
												let newIntegrated = !isIntegrated;
												setIsIntegrated(newIntegrated);
												if (newIntegrated == false) {
													setIntegrationId(0);
												}
											}}
											label="Integrate this metric"
											style={{ marginRight: 10 }}
										/>
										<OverlayTrigger
											placement={"top"}
											overlay={
												<Tooltip id={`tooltip-top`}>
													Integrate metrics are special metrics that integrate into
													other features
												</Tooltip>
											}
										>
											<i
												className="fas fa-info-circle"
												style={{ color: "#525F7F" }}
											></i>
										</OverlayTrigger>
										
									</div>

									{isIntegrated && (
										<div style={{ margin: "10px 0px" }}>
											<select
												value={integrationId}
												onChange={(e) => setIntegrationId(e.target.value)}
											>
												<option value={0} selected>
													---
												</option>
												{metricIntegrations.map((metric) => (
													<option value={metric.value}>{metric.text}</option>
												))}
											</select>
										</div>
									)}
									{integrationId != "0" && (
										<div>
											<div className={classes.MetricsSubHeader}>
												Metric Integrations
											</div>
											<div className={classes.Subtext}>
												The maximum weight at which a person can perform one rep of
												an exercise. Integrates with % Max Calculator on the workout
												creator.
											</div>
										</div>
									)}
									

									<hr />
									<Button
										size="sm"
										// className={classes.ModalBtn}
										style={{float:'right'}}
										variant='success'
										onClick={() => editAssessmentFunc()}
									>
										Edit Metric
									</Button>
								</Form>
							</Modal.Body>
						</Modal>
						{/* manage categories modal */}
						<Modal show={showCategorymodal} onHide={handleCategoryClose}>
							<Modal.Header closeButton>
								<Modal.Title className={classes.ModalTitle}>
									Manage Categories
								</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<Table bordered hover>
									<thead style={{ backgroundColor: "#172B4D", color: "#fff" }}>
										<tr>
											<th>Category</th>
										</tr>
									</thead>
										<tbody> 
												{categories?.map(val => (
													<>
													{val.category === 'General' ? null :
											<tr>
													<td>{val?.category}
													<i
														className={[classes.DeleteIcon, "fa fa-times"].join(
															" "
														)}
														onClick={() => deleteCategoryHandler(val.category_id, val.category)}
														style={{float:"right"}}
													></i>
													</td>
											</tr>
													}
											</>
												))}
										</tbody>

								</Table>
								{showAddCategory ? 
									<Form style={{borderStyle:'solid', borderWidth:'1px', borderColor:'grey', borderRadius:'2px', padding:'10px'}}>
										<Form.Group controlId="formBasicEmail">
											<Form.Label>Create a category</Form.Label>
											<Form.Control type="text" value={categoryName} onChange={(e) => setCategoryName(e.target.value)}/>
										</Form.Group>
										<Button 
											variant="success" 
											type="submit" 
											onClick={handleAddCategory}		 
											disabled={categoryName===''}	
										>
											Submit
										</Button>
									</Form>
								
								: 
								<Button
									variant="outline-success"
									onClick={() => setShowAddCategory(true)}	
								>Create a category</Button>}
							</Modal.Body>
						</Modal>
					</React.Fragment>
					:
					<small>Your trainer must enable your ability to access this list</small>
				}
			</div>
			<CopyMetricModal show={showCopyModal} onHide={()=>{
				setShowCopyModal(false)
			}}/>
		</>
	);
	}
}
export default MetricList;
